import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPerformanceReportForProfessionalsRankingUseCaseInterface } from 'domain/usecases';

export class RemoteGetPerformanceReportForProfessionalsRanking
  implements GetPerformanceReportForProfessionalsRankingUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetPerformanceReportForProfessionalsRankingUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetPerformanceReportForProfessionalsRankingUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsRankingUseCaseInterface.Result> {
    const { ...filters } = params;
    const url = `${this.url}`;
    const requestUrl = generateUrl(url, filters as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return {
          total: httpResponse.body?.total || 0,
          data: httpResponse.body?.data || [],
        };
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
